<div class="card-view-primary-box app-scrollbar">
    <div class="header row align-items-center">
      <div class="col-11 d-flex align-items-end">
        <div class="col-12 d-flex align-items-center">
            <img src="assets/svg/credential-card-grey.svg" alt="badge icon" />
            
            <span class="count pr-10 pl-12">
              {{ recurrentRevenue.totalInvites - recurrentRevenue.invitesAcceptedCount}}
            </span>

            <div class="dashboard-card-header">
            {{ 'REMAINING_INVITATIONS' | translate }}
            </div>
        </div>
      </div>
    </div>

    <hr class="col-12 divider" />
    <app-remaining-invite-dialog [recurrentRevenue]="recurrentRevenue"></app-remaining-invite-dialog>
    <div class="grid-container">
        <div class="grid-item-left text-style">{{ 'ALLOWED_INVITATION' | translate }}</div>
        <div class="grid-item-right num-style">{{ recurrentRevenue.totalInvites ?? MAX_DEFAULT_INVITE }}</div>
        <div class="grid-item-left text-style">{{ 'SENT_INVITATION' | translate }}</div>
        <div class="grid-item-right num-style">{{ recurrentRevenue.inviteCount ?? 0}}</div>
        <div class="grid-item-left text-style">{{ 'ACCEPTED_INVITATION' | translate }}</div>
        <div class="grid-item-right num-style">{{ recurrentRevenue.invitesAcceptedCount ?? 0}}</div>
    </div>

  </div>
  